import { render, staticRenderFns } from "./m_respondSituation.vue?vue&type=template&id=08b64d9a&scoped=true&"
import script from "./m_respondSituation.vue?vue&type=script&lang=js&"
export * from "./m_respondSituation.vue?vue&type=script&lang=js&"
import style0 from "./m_respondSituation.vue?vue&type=style&index=0&id=08b64d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b64d9a",
  null
  
)

export default component.exports